// extracted by mini-css-extract-plugin
export default {"BodyBold":"body-bold_BodyBold__QWOMg"};